import React from 'react'

import Checkbox from '../DMGComponents/Checkbox'
import Button from '../DMGComponents/Button'
import Break from '../DMGComponents/Break'
import ContentIcon from '../assets/img/Folder.png'
import '../assets/css/Table.css'
import getUid from '../utils/uidGenerator';
import { getAdHocAreaContent, getAdHocDownloadInfo } from '../fetchData';
import toast, { Toaster } from 'react-hot-toast';
import ReactSpinner from 'react-bootstrap-spinner';

class AdHocAreaContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            areaContent: [],
            errorLoading: false,
            isLoading: false,
            allSelected: false,
            fileSelected: false
        }

        this.downloadFiles = this.downloadFiles.bind(this);
    }

    componentDidMount() {
        this.props.refreshAreaContent(this.refreshAreaContent);
        this.refreshAreaContent();
    }

    refreshAreaContent = () => {
        this.loadAreaContent(this.props.adHocToken);
    }

    loadAreaContent = (token) => {
        this.setState({
            isLoading: true
        })
        
        getAdHocAreaContent(token).then((res) => {
            let arr = [];
            let overallSize = 0;
            res.forEach(e => {
                arr.push({
                    selected: false,
                    fileName: e.fileName,
                    size: e.sizeInBytes,
                    timestamp: new Date(e.lastWriteTime)
                });
                overallSize += e.sizeInBytes;
            });
            this.setState({
                areaContent: arr,
                errorLoading: false,
                isLoading: false,
                fileSelected: false
            })
        }).catch((err) => {
            console.error("Error", err);
            this.setState({
                errorLoading: true,
                isLoading: false,
                fileSelected: false
            })
            toast.error("Error loading area content.")
        })
    }

    downloadFiles = () => {
        let selectedFiles = []
        for (var i = 0; i < this.state.areaContent.length; i++) {
            let file = this.state.areaContent[i];
            if (file.selected) {
                selectedFiles.push(file.fileName);
            }
        }
        if (selectedFiles.length > 0) {
            this.setState({
                isLoading: true
            })
            getAdHocDownloadInfo(selectedFiles, this.props.adHocToken).then((res) => {
                this.setState({
                    isLoading: false
                })
                let downloadGuid = res;
                var getUrl = window.location;
                var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
                window.location = baseUrl + "api/download/files/" + downloadGuid;
                toast.success("Downloading file(s).")
            }).catch((err) => {
                console.error("Error", err)
                toast.error("Error downloading file(s).");
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    selectFile = (i) => {
        let arr = this.state.areaContent;
        arr[i].selected = !arr[i].selected
        let newAllSelected = this.state.allSelected;
        if (!arr[i].selected && this.state.allSelected) {
            newAllSelected = false;
        }
        let anyFileSelected = this.isAnyFileSelected();
        this.setState({
            areaContent: arr,
            allSelected: newAllSelected,
            fileSelected: anyFileSelected,
        })
    }

    selectAllFiles = (i) => {
        let arr = this.state.areaContent;
        let select = !this.state.allSelected;
        for (var i = 0; i < arr.length; i++) {
            arr[i].selected = select;
        }
        this.setState({
            areaContent: arr,
            allSelected: select,
            fileSelected: select,
        })
    }

    isAnyFileSelected = () => {
        let selected = false;
        for (var i = 0; i < this.state.areaContent.length; i++) {
            let file = this.state.areaContent[i];
            if (file.selected) {
                selected = true;
                break;
            }
        }
        return selected;
    }

    generateTableBody = (array) => {
        return array.map((e, i) => {
            return (
                <tr
                    style={{ cursor: "pointer" }}
                    key={getUid()}
                >
                    <td onClick={() => { this.selectFile(i) }}>
                        <Checkbox style={{ marginLeft: 15 }} checked={e.selected} onClick={(s) => { this.state.areaContent[i].selected = s }} />
                    </td>
                    <td onClick={() => { this.selectFile(i) }}>
                        {e.fileName}
                    </td>
                    <td onClick={() => { this.selectFile(i) }} style={{ textAlign: "center" }}>
                        {Math.round(e.size / 10000 + 100 * Number.EPSILON) / 100 /* Epsilon necessary due to floatingpoint conversion (see 0.1 + 0.2  != 0.3 in javascript) */}
                    </td>
                    <td onClick={() => { this.selectFile(i) }} style={{ textAlign: "center" }}>
                        {e.timestamp.toLocaleString()}
                    </td>
                </tr>
            )
        })
    }

    render() {
        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                    <Button type="hover-bottom-left" onClick={this.refreshAreaContent} >Refresh</Button>
                </div>
                <Break style={{ margin: "16px 0 12px 0" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={ContentIcon}   
                                alt="Area Content"
                                style={{ height: "2rem", position: "absolute" }}
                                />
                        </div>
                        <div>
                            Area Content
                        </div>
                    </div>
                </Break>
                {this.state.errorLoading
                    ? <h3>Error loading area content</h3>
                    : <div>
                        {this.state.isLoading &&
                            <><div style={{ textAlign: "center" }}>
                                <ReactSpinner type="border" color="black" size="3" />
                            </div></>
                        }
                        {!this.state.isLoading &&
                            <div>
                                <table
                                    style={{ width: "100%" }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "30px", textAlign: "center" }}><Checkbox key={getUid()} style={{ marginLeft: 15 }} checked={this.state.allSelected} onClick={() => { this.selectAllFiles() }} /></th>
                                            <th>File</th>
                                            <th style={{ width: "60px", textAlign: "center" }}>Filesize (MB)</th>
                                            <th style={{ width: "180px", textAlign: "center" }}>LastWriteTime</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.generateTableBody(this.state.areaContent)}
                                    </tbody>
                                </table>
                                <br />
                                {this.state.areaContent.length == 0 &&
                                    <div style={{textAlign:"center", fontSize:"20px"}}>No Files Found</div>
                                }
                                {this.state.areaContent.length > 0 &&
                                    <React.Fragment>
                                        {!this.state.fileSelected &&
                                            <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>Please select files from the list above.</div>
                                        }
                                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                                            <Button type="hover-bottom-left" onClick={this.downloadFiles} disabled={!this.state.fileSelected}>Download</Button>
                                        </div>
                                    </React.Fragment>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default AdHocAreaContent;